<mat-toolbar color="primary" class="">
  <div class="top-toolbar-border"></div>
  <mat-toolbar-row *ngIf="isMain" class="mat-elevation-z2">
    <button
      (click)="onMenuClick()"
      mat-icon-button
      class="example-icon"
      aria-label="Example icon-button with menu icon"
    >
      <mat-icon>menu</mat-icon>
    </button>
    <span class="ml-3">
      <img src="/assets/img/logo_neg.svg" class="logo" />
    </span>
    <button
      mat-icon-button
      class="ml-auto"
      [matMenuTriggerFor]="menu"
      *ngIf="showNotifications"
    >
      <mat-icon
        matBadge="{{ notifications.length }}"
        matBadgeColor="warn"
        [matBadgeHidden]="notifications.length == 0"
      >
        notifications</mat-icon
      >
    </button>
    <button mat-icon-button class="d-md-none" (click)="refresh()">
      <mat-icon>refresh</mat-icon>
    </button>
    <mat-menu [class]="'menu-notifications'" #menu="matMenu">
      <div class="text-center">
        <span translate *ngIf="notifications.length == 0"
          >Non ci sono notifiche</span
        >
      </div>
      <mat-list *ngIf="notifications.length > 0">
        <mat-list-item
          (click)="$event.stopPropagation()"
          *ngFor="let notification of notifications"
        >
          <div
            class="d-flex flex-grow-1 align-items-center notification-content"
          >
            <div class="flex-grow-1 border-0" readonly>
              {{ notification.message }}
            </div>
            <button
              mat-icon-button
              class="ml-auto mr-0"
              (click)="onSetNotificationAsRead(notification)"
            >
              <mat-icon>close</mat-icon>
            </button>
          </div>
        </mat-list-item>
      </mat-list>
    </mat-menu>
  </mat-toolbar-row>
  <mat-toolbar-row>
    <button *ngIf="!isMain" (click)="onBackClick()" mat-icon-button>
      <mat-icon>keyboard_backspace</mat-icon>
    </button>
    <span class="title ellipsis">{{ title }}</span>
    <span class="ml-auto" *ngIf="isMain">
      <button
        *ngFor="let c of commands"
        mat-fab
        color="accent"
        class="mt-fab"
        (click)="c.execute()"
        [title]="c.text"
        [hidden]="!(c.canExecute() | async)"
      >
        <mat-icon>{{ c.icon }}</mat-icon>
      </button>
    </span>
    <span class="ml-auto" *ngIf="!isMain">
      <button
        [title]="c.text"
        *ngFor="let c of commands"
        (click)="c.execute()"
        mat-icon-button
        [hidden]="!(c.canExecute() | async)"
      >
        <mat-icon>{{ c.icon }}</mat-icon>
      </button>
    </span>
  </mat-toolbar-row>
</mat-toolbar>
